export default __webpack_public_path__ + "static/media/edo-principes.865b6a3f.png";